import { useEffect, type ReactNode } from "react";

import { applyTheme } from "@/lib/theme";
import { useTheme } from "@/stores/ui";

/**
 * Keeps the document's `dark` class in step with the stored preference, and
 * with the OS preference while the stored value is "system".
 */
export function ThemeProvider({ children }: { children: ReactNode }) {
  const theme = useTheme();

  useEffect(() => applyTheme(theme), [theme]);

  return children;
}
